import React from 'react';
import { motion } from 'framer-motion';

const IMG = {
  jazAfter: 'https://customer-assets-4nw71qhi.emergentagent.net/job_elite-coaching-15/artifacts/uq1oj4nn_jaz%20after.png',
  antonioAfter: 'https://customer-assets-4nw71qhi.emergentagent.net/job_elite-coaching-15/artifacts/y64cwmy4_antonio%20after.png',
  sherryAfter: 'https://customer-assets-4nw71qhi.emergentagent.net/job_elite-coaching-15/artifacts/8wfcj339_sherry%20after.png',
  rosieAfter: 'https://customer-assets-4nw71qhi.emergentagent.net/job_elite-coaching-15/artifacts/knba6l9v_rosie%20after.png',
};

const stories = [
  {
    key: 'jazz',
    name: 'Jazz',
    photo: IMG.jazAfter,
    story: 'Fit into her wedding dress— and returned to running.',
    stats: ['15 in off waist', '+6 lb muscle'],
  },
  {
    key: 'antonio',
    name: 'Antonio',
    photo: IMG.antonioAfter,
    story: 'Built discipline, dropped weight, and gained real strength on his own terms.',
    stats: ['1 Year', '-68 pounds'],
  },
  {
    key: 'sherry',
    name: 'Sherry, Age 61',
    photo: IMG.sherryAfter,
    story: 'Carrying groceries and walking up stairs became easier.',
    stats: ['8 in off waist', '+5 lb muscle'],
  },
  {
    key: 'rosie',
    name: 'Rosie',
    photo: IMG.rosieAfter,
    story: 'Built visible core strength and stayed consistent while traveling.',
    stats: ['2.4 in off waist', '5 months'],
  },
];

export const ClientStories = () => {
  return (
    <section
      data-testid="client-stories"
      className="bg-black py-14 sm:py-16 lg:py-20 px-6 border-b border-neutral-900"
    >
      <div className="container mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.7 }}
          className="text-center mb-10 lg:mb-14"
        >
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="h-px w-16 bg-neutral-700" />
            <p className="text-gray-400 font-bold text-xs tracking-[0.35em] uppercase whitespace-nowrap">
              Client Stories
            </p>
            <div className="h-px w-16 bg-neutral-700" />
          </div>
          <h2 className="font-display text-white text-4xl sm:text-5xl lg:text-6xl uppercase leading-none">
            What Strength Changes.
          </h2>
          <p className="text-gray-400 text-sm sm:text-base mt-4 max-w-xl mx-auto">
            The numbers matter. So does what becomes possible.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {stories.map((s, i) => (
            <motion.div
              key={s.key}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.65, delay: i * 0.08 }}
              data-testid={`client-story-${i}`}
              className="rounded-2xl border border-neutral-800 bg-neutral-950 overflow-hidden hover:border-neutral-600 transition-colors flex flex-col"
            >
              <div className="relative aspect-[4/5] w-full overflow-hidden bg-neutral-900">
                <img
                  src={s.photo}
                  alt={s.name}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover object-top"
                />
                <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-neutral-950 to-transparent" />
              </div>

              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-display text-white text-lg uppercase leading-tight">{s.name}</h3>
                <p className="text-gray-300 text-sm leading-relaxed mt-3">{s.story}</p>
                <div className="h-px bg-neutral-800 my-4" />
                <div className="space-y-1 mt-auto">
                  {s.stats.map((stat, idx) => (
                    <p key={idx} className="text-white font-display uppercase text-xs tracking-[0.15em]">
                      • {stat}
                    </p>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
